import Swiper from "swiper"
import { Navigation, Autoplay } from "swiper/modules"
import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

import 'swiper/css';
import "swiper/css/autoplay"

class SmvProjects extends HTMLElement {

  constructor() {
    super();
  }


  connectedCallback() {
    // Check if user prefers reduced motion
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const slides = this.querySelectorAll('.swiper-slide');
    if (slides.length > 1) {
      const swiper = new Swiper(this.querySelector('.swiper'), {
        modules: [Navigation, Autoplay],
        navigation: {
          nextEl: ".swiper-navigation-next",
          prevEl: ".swiper-navigation-prev",
        },
        slidesPerView: 1,
        spaceBetween: 100,
        speed: 750,
        loop: true,
        autoplay: prefersReducedMotion ? false : {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        on: {
          afterInit: () => {
            ScrollTrigger.refresh();
          }
        }
      });
    }
  }

}

// Define the new web component
if ('customElements' in window) {
  customElements.define('smv-projects', SmvProjects);
}
